import CrashDetectionMonitorPage from '@/components/feature/CrashDetectionMonitorPage'

function CrashDetectionMonitor() {
  return (
    <>
      <CrashDetectionMonitorPage />
    </>
  )
}

export default CrashDetectionMonitor
